(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/header-slide-down-menu/assets/javascripts/header-slide-down-menu.js') >= 0) return;  svs.modules.push('/components/components/header-slide-down-menu/assets/javascripts/header-slide-down-menu.js');

var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  var log = svs.core.log.getLogger('component:HeaderSlideDownMenu');

  svs.components.HeaderSlideDownMenu = function() {
    var viewContainer;
    var content;
    var menuBtn;
    var overlay;
    var swiper;
    var headerConf;
    var gamesView;
    var buttonObject;
    var config = {
      customBtnClass: 'header-menu-button-default',
      btnText: 'Pågående spel',
      headerView: undefined,
      view: '',
      viewOptions: null,
      onHide: false,
      onShow: false,
      useSwiper: true,
      placeLast: false,
      disableOverlay: false
    };

    var init = function(options) {
      options = options || {};

      var templateConfig = svs.core.template.getConfig();

      headerConf = {
        title: templateConfig.title,
        leftButtons: templateConfig.leftButtons,
        rightButtons: templateConfig.rightButtons
      };

      headerConf.leftButtons = headerConf.leftButtons || [];

      if (!options.view || options.view === '') {
        log.error('No view set in options, options.view is: ', options.view);
        return {};
      }
      var body = $('body');
      body.append(svs.components.header_slide_down_menu.templates.header_slide_down_menu({
        showInlineCloseButton: Boolean(templateConfig.hasBalanceBar)
      }));
      var heading = $('.header-slide-menu-heading');

      if (templateConfig.hasBalanceBar) {
        $('.js-slide-down-close').on('click', toggle);
      }

      viewContainer = $('.header-slide-down-menu-container');
      content = $('.header-slide-down-menu-content');
      overlay = $('.header-slide-down-menu-overlay');

      body.on('click', '.header-slide-down-menu-overlay', function() {
        hide();
      });

      for (var prop in options) {
        if (Object.prototype.hasOwnProperty.call(config, prop)) {
          config[prop] = options[prop];
        }
      }

      if (
        typeof config.headerView === 'object' &&
        typeof config.headerView.render === 'function'
      ) {
        heading.html(config.headerView.render().el);
      }

      if (
        svs.utils.ns.isNamespace('React.isValidElement') &&
        typeof React.isValidElement === 'function' &&
        React.isValidElement(options.view) &&
        svs.utils.ns.isNamespace('ReactDOM.render') &&
        typeof ReactDOM.render === 'function'
      ) {
        ReactDOM.render(options.view, content.get()[0]);
      } else if (
        typeof options.view === 'string' ||
        typeof options.view === 'object'
      ) {
        if (options.view.render) {
          content.html(options.view.render().el);
        } else {
          content.html(options.view);
        }
      } else {
        gamesView = new options.view(options.viewOptions || null);
        gamesView.render();
        content.html(gamesView.$el);
      }

      buttonObject = {
        cssClass:
          'header-menu-button btn btn-100 margin-right-1 ' +
          config.customBtnClass,
        content:
          '<span class="header-menu-closed">' +
          config.btnText +
          '</span><span class="header-menu-opened"><i class="icon-default icon-close" title="stäng"></i></span>',
        id: 'header-menu-button',
        action: toggle
      };

      if (config.placeLast) {
        headerConf.leftButtons.push(buttonObject);
      } else {
        headerConf.leftButtons.unshift(buttonObject);
      }

      svs.core.template.updateConfig(headerConf);

      if (config.useSwiper) {
        swiper = new svs.components.Swiper();
        var swiperOptions = {
          scrollbars: false,
          scrollingX: false,
          scrollingY: true
        };
        swiper
          .init(content[0], swiperOptions)
          .addEventListener('reachedend', function() {
            $(window.document).trigger('ongoing-games-scroll-end');
          });

        $(window).resize(swiper.scroller.updateDimensions);

        swiper.scroller.addEventListener('scroll', function(scrollPos) {
          if (scrollPos.scrollTop > 0) {
            heading.addClass('scrolled');
          } else {
            heading.removeClass('scrolled');
          }
        });
      }
    };

    var toggle = function() {
      var toggleClasses = 'header-menu-open animate-menu-overlay-visible';

      if (config.disableOverlay) {
        toggleClasses += ' header-menu-disable-overlay';
      }

      viewContainer.toggleClass('header-menu-open animate-menu-from-top-open');
      $('.header-menu-button').toggleClass('header-menu-open');
      overlay.toggleClass(toggleClasses);

      if (config.onHide && !overlay.hasClass('header-menu-open')) {
        config.onHide();
      } else if (config.onShow && overlay.hasClass('header-menu-open')) {
        config.onShow();
      }
    };

    var show = function() {
      menuBtn = menuBtn || $('.header-menu-button');

      var autoHideTime = arguments[0] || 0;
      var toggleClasses = 'header-menu-open animate-menu-overlay-visible';

      if (config.disableOverlay) {
        toggleClasses += ' header-menu-disable-overlay';
      }

      viewContainer.addClass('header-menu-open animate-menu-from-top-open');
      menuBtn.addClass('header-menu-open');
      overlay.addClass(toggleClasses);

      if (autoHideTime) {
        setTimeout(function() {
          hide();
        }, autoHideTime);
      }
      if (config.onShow) {
        config.onShow();
      }
    };

    var hide = function() {
      menuBtn = menuBtn || $('.header-menu-button');
      if (viewContainer) {
        viewContainer.removeClass('header-menu-open animate-menu-from-top-open');
      }

      if (menuBtn) {
        menuBtn.removeClass('header-menu-open');
      }

      if (overlay) {
        overlay.removeClass('header-menu-open animate-menu-overlay-visible header-menu-disable-overlay');
      }

      if (config.onHide) {
        config.onHide();
      }
    };

    var remove = function() {
      if (swiper) {
        $(window).off('resize', swiper.scroller.updateDimensions);
        if (swiper.scroller) {
          swiper.scroller.destroy();
        }
      }

      viewContainer.remove();
      overlay.remove();

      if (headerConf.leftButtons) {
        for (var i = 0; i < headerConf.leftButtons.length; i++) {
          if (headerConf.leftButtons[i].id === 'header-menu-button') {
            headerConf.leftButtons.splice(i, 1);
          }
        }
      }

      if (gamesView && gamesView.dispose) {
        gamesView.dispose();
      }

      svs.core.template.updateConfig(headerConf);
    };

    return {
      init: init,
      show: function() {
        show.apply(this, arguments);
      },
      hide: hide,
      toggle: toggle,
      remove: remove,
      getContentElement: function() {
        return document.querySelector('.header-slide-down-menu-content');
      }
    };
  };

  svs.components.headerslidedownmenu = new svs.components.HeaderSlideDownMenu();
})(svs);


 })(window);